interface IAssortment {
    id: string;
}

export interface IAssortmentResponse {
    collection: IAssortment;
}

export interface ICreateAssortmentRequest {
    type: string;
    name: string;
    merchantId: string;
    targetMerchantId?: string;
    brandId?: string;
    parentId: string;
    excludedAllocationDimensionValues?: {
        [allocationDimensionId: string]: string[];
    };
    inventoryEnabled?: boolean;
    allocationBagVersion1?: boolean;
    dimensionValues?: {
        [dimensionId: string]: string[];
    };
}

export interface ICreateRollupAssortmentRequest {
    name: string;
    assortments: nuorder.folder.v1.Item[];
    merchantId: string;
    parentId: string;
    parentName?: string;
}

export interface IEditRollupAssortmentRequest {
    name: string;
    assortments: nuorder.folder.v1.Item[];
    merchantId: string;
    parentId: string;
    rootItemId?: string;
}

export enum CollectionType {
    External = "SINGLE_BRAND",
    Internal = "RETAILER",
    BrandStandard = "BRAND_STANDARD",
    Vertical = "VERTICAL",
}
